export default __webpack_public_path__ + "static/NotoSans-Italic.subset-b1fd027ac0bf03bf5ff540265629b0ac.otf";